import { ErrorHandler } from '@angular/core';
import { config } from '../config';
import * as Sentry from '@sentry/browser';

if (config.sentryPublicDsn) {
  Sentry.init({
    dsn: config.sentryPublicDsn
  });
}

export class SentryHandler extends ErrorHandler {
  handleError(err: any) {
      if (err.status && err.status !== 401) {
        Sentry.captureException(this.unwrapException(err));
      }

      super.handleError(err);
  }

  private unwrapException(error: any) {
    while (error.originalError) {
      error = error.originalError;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/sentry-handler.ts